import apiCall from 'shared/utils/apiCall';
import apolloClient from 'store/apolloClient';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';

import createAction from './index';
import * as services from '../services/fetchConsentData';
import { addToast } from '../../messageSystem/actions/addToast';

const FETCH_APPOINTMENT_CONSENT_MESSAGE = createAsyncAction(createAction('FETCH_APPOINTMENT_CONSENT_MESSAGE'));


export const fetchConsentData = (appointmentId) => dispatch => {
  dispatch({ type: FETCH_APPOINTMENT_CONSENT_MESSAGE.pending });

  const apiCallParams = {
    query: services.FETCH_APPOINTMENT_CONSENT_MESSAGE,
    variables: { appointmentId },
    fetchPolicy: 'no-cache',
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then(({ data: { getFutureAppointmentConsentMessage: payload } }) =>
      dispatch({
        type: FETCH_APPOINTMENT_CONSENT_MESSAGE.success,
        payload,
      }),
    )
    .catch((err) => dispatch(errorAction(FETCH_APPOINTMENT_CONSENT_MESSAGE.failure, err)));
};

export const declineConsent = (declineMessage) => addToast(
  'info',
  'appt-consent-decline',
  declineMessage,
);
